import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import getSettings from 'common/utils/settings';
import Title from 'components/Title';
import computeInvestment from 'common/model/simulation/dismemberedScpi/computeInvestment';
import formatPercentage from 'common/utils/format/percentage';
import colors from 'components/colors';

const chartSize = 350;

const formatLabel = ({ value }) => formatPercentage(value);

const chartData = (details, duration) => details.map(({ type, parts }, index) => {
    const dismemberedScpi = getSettings(['simulation', 'dismemberedScpi', type]);

    return {
        name: dismemberedScpi.name,
        value: (parts * dismemberedScpi.value) / computeInvestment(duration)(details),
        fill: colors[index],
    };
});

const Allocations = ({
    data: { products, duration },
}) => (
    <Fragment>
        <Title><b>Répartition de votre investissement</b></Title>
        <div className="investor-profile-resume">
            <div className="investor-profile-chart">
                <ResponsiveContainer height={chartSize} width="80%">
                    <PieChart height={chartSize} width={chartSize}>
                        <Pie
                            data={chartData(products, duration)}
                            dataKey="value"
                            nameKey="name"
                            isAnimationActive={false}
                            label={formatLabel}
                            legendType="circle"
                        />
                        <Legend
                            layout="vertical"
                            verticalAlign="middle"
                            align="left"
                            wrapperStyle={null}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    </Fragment>
);

Allocations.propTypes = {
    data: PropTypes.shape({
        products: PropTypes.arrayOf(PropTypes.shape({
            type: PropTypes.string.isRequired,
            parts: PropTypes.number.isRequired,
            revaluation: PropTypes.string,
        })).isRequired,
        duration: PropTypes.number,
    }).isRequired,
};

export default Allocations;
